export const GET_TRANSACTION_NETWORK_DEF= "GET_TRANSACTION_NETWORK_DEF"
export const GET_TRANSACTION_NETWORK_DEF_SUCCESS = "GET_TRANSACTION_NETWORK_DEF_SUCCESS"
export const GET_TRANSACTION_NETWORK_DEF_FAIL = "GET_TRANSACTION_NETWORK_DEF_FAIL"

export const TRANSACTION_NETWORK_DEF_API_ERROR = "API_ERROR"